import React, { useState } from "react";
import {
  Box,
  ButtonGroup,
  Text
} from "@primer/react";
import { useCommonContext } from "../../../contexts/common";
import { NotifyHelper } from "../../../helpers/toast";
import Modal from "../../../components/ui/modal";
import Button from "../../../components/ui/button";
import { hocSinhNoiTruApi } from "../../../api/hocSinhNoiTruApi";

interface XoaKhoiPhongModalProps {
  selectedIds: number[];
  onClose: () => void;
  onSuccess: () => void;
}

const XoaKhoiPhongModal: React.FC<XoaKhoiPhongModalProps> = ({
  selectedIds,
  onClose,
  onSuccess,
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const { translate } = useCommonContext();

  const handleSubmit = async () => {
    setIsSaving(true);
    try {
      const res = await hocSinhNoiTruApi.removeFromPhong(selectedIds);
      
      if (res.is_success) {
        NotifyHelper.Success(translate("Success.Update"));
        onSuccess();
      } else {
        NotifyHelper.Error(res.message || translate("Error.UpdateFailed"));
      }
    } catch (error) {
      NotifyHelper.Error(translate("Error.Generic"));
    }
    setIsSaving(false);
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      width="medium"
      title={translate("Xóa khỏi phòng")}
    >
      <Box sx={{ mb: 3 }}>
        <Text>
          {translate("Bạn có chắc chắn muốn xóa các học sinh đã chọn khỏi phòng?")}
        </Text>
   
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <ButtonGroup>
          <Button onClick={onClose}>
            {translate("Base.Label.Cancel")}
          </Button>
          <Button 
            variant="danger" 
            onClick={handleSubmit}
            disabled={isSaving}
          >
            {translate("Base.Label.Delete")}
          </Button>
        </ButtonGroup>
      </Box>
    </Modal>
  );
};

export default XoaKhoiPhongModal;